import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageType, ImageTypeCompare, StringConst } from 'src/app/constants/const';
import { Container, ImageViewerStructor } from 'src/app/model/http/container-selector.model';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImageViewerComponent implements OnInit {

  typeCompare = ImageTypeCompare;
  container?: Container;
  image = StringConst.empty;
  title = StringConst.empty;
  constructor(@Inject(MAT_DIALOG_DATA) public data: ImageViewerStructor) { }

  ngOnInit(): void {
    this.image = this.data.product.imgProduct;
  }

}
